module.exports = __webpack_public_path__ + "img/arbre_2.4ed48a76.png";